import { getDefaultSettings, RootStoreProps } from '@platform/front-core';

const { env, history, palette } = getDefaultSettings(process.env);

const features: RootStoreProps['features'] = require(`./customization/features`).default;

let ru = {};
let en = {};

try {
    ru = require(`./customization/locales/ru`).default;
    en = require(`./customization/locales/en`).default;
} catch (e) {}

const locales: RootStoreProps['locales'] = { ru, en };

export { env, features, locales, history, palette };
